import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, ClickAwayListener, Grid } from '@mui/material';
import { APP_BAR_Z_INDEX, FILTER_FLOAT_BUTTON_Z_INDEX } from 'src/const';

const BottomDrawer = ({
  topComponents,
  components,
  isOverLayVisible,
  overlayButton,
}: {
  topComponents: JSX.Element[];
  components: JSX.Element[];
  isOverLayVisible: boolean;
  overlayButton: JSX.Element;
}) => {
  const defaultHeight = 110;

  const [dragStart, setDragStart] = useState(null);
  const [drawerHeight, setDrawerHeight] = useState(defaultHeight);

  const drawerRef = useRef<HTMLDivElement | null>(null);

  const scrollDrawerToTop = () => {
    if (drawerRef?.current) {
      drawerRef.current.scrollTop = 0;
    }
  };

  const handleMouseDown = e => {
    setDragStart(e.clientY);
  };

  const handleMouseMove = e => {
    if (dragStart !== null) {
      const deltaY = dragStart - e.clientY;
      setDrawerHeight(prevHeight => Math.max(50, prevHeight + deltaY));
      setDragStart(e.clientY);
    }
  };

  const handleMouseUp = () => {
    setDragStart(null);
  };

  const handleTouchStart = e => {
    setDragStart(e.touches[0].clientY);
  };

  const handleTouchMove = e => {
    if (dragStart !== null) {
      const deltaY = dragStart - e.touches[0].clientY;
      setDrawerHeight(prevHeight => Math.max(20, prevHeight + deltaY));
      setDragStart(e.touches[0].clientY);
    }
  };

  const handleTouchEnd = () => {
    setDragStart(null);
    // scrollDrawerToTop();
  };

  return (
    <>
      <ClickAwayListener onClickAway={() => setDrawerHeight(defaultHeight)}>
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            // height: `${drawerHeight}px`,
            height: '40vh',
            maxHeight: '80vh',
            borderTopLeftRadius: 16,
          }}
        >
          <Box
            sx={{
              height: '30px',
              display: 'flex',
              justifyContent: 'space-between',
              padding: 'auto 5px',
              paddingLeft: '10px',
              marginRight: '10px',
              paddingBottom: '5px',
              // border: '2px solid red'
            }}
          >
            {topComponents.map(component => component)}
          </Box>
          <Box
            sx={{
              background: '#fff',
              width: '100%',
              height: '100%',
              margin: 'auto',
              paddingLeft: '5px',
              overflow: 'auto',
              position: 'relative',
            }}
            ref={drawerRef}
          >
            {isOverLayVisible && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '3400px',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  zIndex: FILTER_FLOAT_BUTTON_Z_INDEX - 1,
                }}
              >
                <div
                  style={{
                    position: 'sticky',
                    top: '25%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  {overlayButton}
                </div>
              </Box>
            )}

            <Box
              sx={{
                height: '30px',
                width: '100%',
                backgroundColor: '#fff',
                cursor: 'grab',
                position: 'fixed',
                left: 0,
                zIndex: APP_BAR_Z_INDEX,
                // display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'none', // controller bottom bar
              }}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <Box sx={{ width: '50px', height: '16px', borderRadius: 200, background: '#ccc' }} />
            </Box>

            <Grid container xs={12} spacing={1} sx={{ marginTop: '20px' }}>
              {components.map(component => (
                <Grid item xs={12}>
                  {component}
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Drawer with draggable picker */}
          {/* <Box
        sx={{        
            height: '50px'  ,
            width: '200px',
          background: 'pink',
          overflow: 'hidden',
        }}
      > */}
        </Box>
      </ClickAwayListener>
    </>
  );
};

export default BottomDrawer;
